import { createAction, props } from '@ngrx/store';

import { RemoteConfigAppResponse, RemoteConfigBanners } from '@vi-iot/client';

export namespace RemoteConfigActions {
  export enum Type {
    GET_REMOTE_CONFIG = '[REMOTE_CONFIG] Get RemoteConfig',
    GET_REMOTE_CONFIG_SUCCESS = '[REMOTE_CONFIG] Get RemoteConfig Success',
    GET_REMOTE_CONFIG_ERROR = '[REMOTE_CONFIG] Get RemoteConfig Error',
    SHOW_BANNER = '[REMOTE_CONFIG] Show banner',
    CLOSE_BANNER = '[REMOTE_CONFIG] Close banner',
    CLOSE_BANNER_SUCCESS = '[REMOTE_CONFIG] Close banner success',
  }

  export const getRemoteConfig = createAction(Type.GET_REMOTE_CONFIG, props<{ appId: string }>());

  export const getRemoteConfigSuccess = createAction(
    Type.GET_REMOTE_CONFIG_SUCCESS,
    props<{ remoteConfig: RemoteConfigAppResponse }>()
  );

  export const getRemoteConfigError = createAction(
    Type.GET_REMOTE_CONFIG_ERROR,
    props<{ error: any }>()
  );

  export const showBanner = createAction(
    Type.SHOW_BANNER,
    props<{ isBannerHidden: boolean; banner: RemoteConfigBanners }>()
  );

  export const closeBanner = createAction(
    Type.CLOSE_BANNER,
    props<{ banner: RemoteConfigBanners }>()
  );

  export const closeBannerSuccess = createAction(
    Type.CLOSE_BANNER_SUCCESS,
    props<{ banner: RemoteConfigBanners }>()
  );
}
